import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { autoinject, inject } from '../Utils/AutoInject';
import { bind } from '../Utils/Bind';
import { BsXCircle } from '@react-icons/all-files/bs/BsXCircle';

export interface IInfoOverlayProps {
    readonly title: string;
    readonly info: string;
    readonly className?: string;
    readonly titleInBody?: boolean;
}

@autoinject
@observer
export class InfoOverlay extends React.Component<IInfoOverlayProps> {
    public render() {
        return (
            <>
                <a onClick={this.showInfo} className="btn-link">
                    {this.props.children ?? <span onMouseEnter={action(() => (this.showing = true))}>Details</span>}
                </a>

                {this.showing && this.renderOverlay()}
            </>
        );
    }

    @bind
    private renderOverlay() {
        return (
            <div
                className={this.props.className + ' card-overlay h-100'}
                onMouseLeave={action(() => (this.showing = false))}
            >
                <div className="overlay-header">
                    {!this.props.titleInBody && <h6 className="d-inline-block p-2 m-0">{this.props.title}</h6>}

                    <a onClick={this.showInfo} className="float-end p-2">
                        <BsXCircle />
                    </a>
                </div>

                <div className="p-2">
                    {this.props.titleInBody && <h6 className="d-inline-block">{this.props.title}</h6>}

                    <p>{this.props.info}</p>
                </div>
            </div>
        );
    }

    @bind
    @action
    private showInfo(event: React.MouseEvent<HTMLAnchorElement>) {
        this.showing = !this.showing;
    }

    @observable
    private showing: boolean = false;
}
